import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@box-env/environment';
import { Location, APIResponse } from '@box-types';
import { normalizeLocation, filterValidLocations } from '@box/utils';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class LandingLocationsService {
  private BOX_API: string = environment.application.API_URL;

  constructor(private http: HttpClient) {}

  public fetchGroupedLocations(): Observable<Location[]> {
    return this.http.get(`${this.BOX_API}/location/getAll`).pipe(
      map((response: APIResponse<{ locations: Location[] }>) => {
        const locations = response.payload.locations;
        const filteredLocations = filterValidLocations(locations) as Location[];
        return filteredLocations.map((location) => normalizeLocation(location));
      })
    );
  }
}
